import React from 'react'
import { SvgIconProps } from '@mui/material'
import { UserStatus } from '$common/user-status'
import { UserListItem } from './user-list-item'

interface Props {
  userId: string | undefined
  role?: string
  SecondaryActionIcon?: React.ComponentType<SvgIconProps>
  hasDivider?: boolean
  onClick?: () => unknown
  onContextMenu?: (e: Event) => unknown
  onSecondaryActionIconClick?: () => unknown
  selected?: boolean
}

export function UserListItemWithStatus({
  userId,
  role = '',
  SecondaryActionIcon,
  hasDivider,
  onClick,
  onContextMenu,
  onSecondaryActionIconClick,
  selected,
}: Props) {
  return (
    <UserListItem
      userId={userId}
      selected={selected}
      role={role}
      secondaryText={<UserStatus userId={userId} />}
      SecondaryActionIcon={SecondaryActionIcon}
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
    />
  )
}
